import { Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events.js'
import { MediaSwitch } from '../utils/media-switch.js'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
import ArrowAnimation from '../animations/dde_arrow_animation.json'
import HeaderAnimationLandscape from '../animations/dde_header_landscape.json'
import HeaderAnimationPortrait from '../animations/dde_header_portrait.json'
import lottie from 'lottie-web'

gsap.registerPlugin(ScrollToPlugin)

// -- Header Arrow ------------------------------------------------- //
class HeaderArrow {
	constructor(el) {
		this.el = el
		this.elFigure = this.el.querySelector('figure')

		this.bndOnClick = this.onClick.bind(this)
		this.el.addEventListener('click', this.bndOnClick)

		this.arrowAnimation = lottie.loadAnimation({
			container: this.elFigure, // the dom element that will contain the animation
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: ArrowAnimation,
		})

		this.setupArrowAnimation()
	}
	setupArrowAnimation() {}
	onClick() {
		this.scrollDown()
	}
	scrollDown() {
		gsap.to(window, {
			duration: 0.8,
			scrollTo: window.innerHeight,
			ease: 'power4.out',
		})
	}
	destroy() {
		this.el.removeEventListener('click', this.bndOnClick)
		this.arrowAnimation.destroy()
	}
}

// -- Logo Animation ------------------------------------------------- //
class LogoAnimation {
	constructor(el) {
		this.el = el
		this.elFigure = this.el.querySelector('.page-hero__logo figure')

		this.bndOnOrientationChange = this.onOrientationChange.bind(this)
		window.addEventListener('orientationchange', this.bndOnOrientationChange)

		this.setup()
	}
	setup() {
		this.destroyAnimation()

		const isLandscape = window.matchMedia('(orientation: landscape)').matches
		const animationData = isLandscape ? HeaderAnimationLandscape : HeaderAnimationPortrait

		this.logoAnimation = lottie.loadAnimation({
			container: this.elFigure, // the dom element that will contain the animation
			renderer: 'svg',
			loop: false,
			autoplay: false,
			animationData,
		})

		setTimeout(() => {
			this.logoAnimation.play()
		}, 250)
	}
	onOrientationChange() {
		setTimeout(() => {
			this.setup()
		}, 0)
	}
	destroyAnimation() {
		if (this.logoAnimation) {
			this.logoAnimation.destroy()
			this.logoAnimation = null
		}
	}
	destroy() {
		window.removeEventListener('orientationchange', this.bndOnOrientationChange)
		this.destroyAnimation()
	}
}

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		this.elArrowButton = this.element.querySelector('.js-arrow-button')
		if (this.elArrowButton) {
			this.headerArrow = new HeaderArrow(this.elArrowButton)
		}

		const elMediaSwitch = this.element.querySelector('[data-media-switch]')
		if (elMediaSwitch) {
			this.mediaSwitch = new MediaSwitch(elMediaSwitch)
		}

		if (this.element.classList.contains('page-hero--logo')) {
			this.logoAnimation = new LogoAnimation(this.element)
		}
	}
	mount() {
		// console.log(window.lenis)
		// this.headerColor = new HeaderColor(this.element, {})
	}
	unmount() {
		if (this.mediaSwitch) {
			this.mediaSwitch.destroy()
		}

		if (this.headerArrow) {
			this.headerArrow.destroy()
		}

		if (this.logoAnimation) {
			this.logoAnimation.destroy()
		}
	}
}
